export default __webpack_public_path__ + "static/media/gallery_08.933994b7.jpg";